import http from '../lib/axios';
var api = {
  get: function get(route) {
    var allowAnonymous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var signal = arguments.length > 2 ? arguments[2] : undefined;
    return http.get(route, {
      allowAnonymous: allowAnonymous,
      signal: signal
    });
  },
  put: function put(route, data, signal) {
    return http.put(route, data, {
      headers: {
        'content-type': 'application/json'
      },
      signal: signal
    });
  },
  post: function post(route, data, signal) {
    return http.post(route, data, {
      headers: {
        'content-type': 'application/json'
      },
      signal: signal
    });
  },
  "delete": function _delete(route, data, signal) {
    return http["delete"](route, {
      data: data != null ? data : null,
      signal: signal
    });
  },
  getFile: function getFile(id) {
    return http.get("fileItems/".concat(id), {
      responseType: 'blob'
    });
  },
  getLinkFile: function getLinkFile(route) {
    var allowAnonymous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return http.get(route, {
      allowAnonymous: allowAnonymous,
      responseType: 'blob'
    });
  },
  postFile: function postFile(route, file, signal) {
    var formData = new FormData();
    formData.append('file', file);
    return http.post(route, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      signal: signal
    });
  }
};
export default api;